import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManagedContent } from '../../../../core/models/fna';
import { GlobalsService } from '../../../../core/services/globals.service';

@Component({
  selector: 'app-multi-step-modal',
  templateUrl: './multi-step-modal.component.html',
  styleUrls: ['./multi-step-modal.component.scss'],
})
export class MultiStepModalComponent implements OnInit, AfterViewInit {
  @Input() tncContent: ManagedContent[] = [];
  @ViewChildren('contentContainer')
  contentContainerList!: QueryList<ElementRef>;
  @ViewChild('multiStepModalBody') modalBody: ElementRef | null = null;

  scrollPercentage = 0;
  sectionHeights: number[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    public globals: GlobalsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    console.log('[MultiStepModalComponent] OnInit');
  }

  ngAfterViewInit() {
    this.sectionHeights = this.contentContainerList
      .toArray()
      .map((elem) => elem.nativeElement.offsetHeight)
      .filter((a) => a);

    this.changeDetectorRef.detectChanges();
  }

  onClickClose() {
    if (this.globals.simulateServerBehaviour) {
      this.globals.mockHasReadPurposeOfFormModal = true;
    }

    this.activeModal.close();
  }

  scrollTo(sectionIndex: number) {
    this.contentContainerList
      .toArray()
      [sectionIndex].nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
  }

  // region getters
  get stepperWidth(): number {
    if (this.numberOfSteps === 0) {
      return 0;
    }

    if (this.numberOfSteps === 1) {
      return 100;
    }

    if (this.activeStep == this.numberOfSteps - 1) {
      return 100;
    }

    const min = this.scrollPercentageBreakpoints[this.activeStep];
    const max = this.scrollPercentageBreakpoints[this.activeStep + 1];

    const valuePerStep = 100 / (this.numberOfSteps - 1);
    const total = max - min;
    const value = this.scrollPercentage - min;
    const normalizedValue = (value / total) * valuePerStep;

    return this.activeStep * valuePerStep + normalizedValue;
  }

  get numberOfSteps(): number {
    return this.sectionHeights.length;
  }

  get scrollPercentageBreakpoints(): number[] {
    if (!this.modalBody) {
      return [];
    }

    const scrollableHeight =
      this.modalBody.nativeElement.scrollHeight -
      this.modalBody.nativeElement.clientHeight;

    if (scrollableHeight === 0) {
      return [];
    }

    let sum = 0;
    return this.sectionHeights
      .map((height) => (height / scrollableHeight) * 100)
      .map((scrollablePercentage, index) => {
        let previousSum = sum;
        sum += scrollablePercentage;
        return Math.min(100, previousSum);
      });
  }

  get activeStep(): number {
    for (let i = 0; i < this.scrollPercentageBreakpoints.length; i++) {
      if (i === this.scrollPercentageBreakpoints.length - 1) {
        return i;
      }

      const currentBreakpoint = this.scrollPercentageBreakpoints[i];
      const nextBreakpoint = this.scrollPercentageBreakpoints[i + 1];
      const tolerance = 0.0;

      if (
        this.scrollPercentage - currentBreakpoint >= -tolerance &&
        this.scrollPercentage - nextBreakpoint < -tolerance
      ) {
        return i;
      }
    }

    return this.scrollPercentageBreakpoints.length - 1;
  }
  // endregion
}
